import index from "./Login.vue";
export default index;
